import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import AudioComponentEditable from './AudioEditable';
import AudioComponentReadOnly from './AudioReadOnly';

const AudioNodeView: React.FC = () => {
  const { node, view } = useReactNodeView();

  if (!view?.editable) {
    return <AudioComponentReadOnly {...node?.attrs} />;
  }

  return <AudioComponentEditable {...node?.attrs} />;
};

export default AudioNodeView;
